module.exports = __webpack_public_path__ + "img/Search_Error.732dc01a.png";